import * as z from 'zod';

export const validationErrors = {
  default: 'default',
  tooShort: 'tooShort',
  tooLong: 'tooLong',
};

export const ratingParser = z.number().min(1).max(5);

export const tagInputParser = z.string().min(2).max(30);

export const createReviewFormSchema = z.object({
  productId: z.string(),
  rating: ratingParser,
  recommended: z.boolean().or(z.null()),
  title: z.string().optional(),
  location: z.string().optional(),
  name: z
    .string()
    .min(2, validationErrors.tooShort)
    .max(30, validationErrors.tooLong)
    .or(z.string().max(0)),
  description: z.string().min(5),
  accept: z.literal(true),
});

export type CreateReviewFormSchema = z.infer<typeof createReviewFormSchema>;
